import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllCurricularUnitsUserResponse } from 'domain/models';

interface ICurricularUnitsState {
  curricularUnitsUser: GetAllCurricularUnitsUserResponse[];
  loadingCurricularUnitsUser: boolean;
}

interface IPayloadCurricularUnitsUser
  extends PayloadAction<GetAllCurricularUnitsUserResponse[]> {}

const initialState: ICurricularUnitsState = {
  curricularUnitsUser: [],
  loadingCurricularUnitsUser: false,
};

export const CurricularUnitsSlice = createSlice({
  name: 'curricularUnits',
  initialState,
  reducers: {
    loadCurricularUnitsUser: (state, action: IPayloadCurricularUnitsUser) => {
      state.curricularUnitsUser = action.payload;
    },
    setLoadingCurricularUnitsUser: (state, action: PayloadAction<boolean>) => {
      state.loadingCurricularUnitsUser = action.payload;
    },
  },
});

export const { loadCurricularUnitsUser, setLoadingCurricularUnitsUser } =
  CurricularUnitsSlice.actions;

export default CurricularUnitsSlice.reducer;
